import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const TooltipContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const MenuItemWithTooltip = styled.div`
    display: flex;
    align-items: center;
`;

export const TooltipText = styled.span`
    ${Fonts.Heading.H600}
`;

export const tooltipOverrides = css`
    .ant-popover-inner-content {
        background-color: ${Colors.WHITE};
    }

    .ant-popover-arrow .ant-popover-arrow-content,
    .ant-popover-arrow .ant-popover-arrow-content:before {
        background-color: ${Colors.WHITE};
    }
`;
